import React, { useEffect, useRef, useState } from 'react';
import { animateScroll } from 'react-scroll';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, CircularProgress, Divider, Grid, Typography } from '@material-ui/core';

import EditFieldsModal from '../EditFieldsModal';
import SkeletonLoading from '../SkeletonLoading';
import swal from 'sweetalert2';

import requestFieldsConfig from './fields/request.fields.config';
import loginService from '../../domain/services/login.service';
import RequestHearingAdditionalModal from './request.hearing.additional.modal';
import RequestAdditionalChargeByProcessDocument from './request.additional.charge.by.process.document';
import documentsService from "../../domain/services/solicitation/documents.service";
import clientLogger from "../../domain/services/logging/client.logger";
import { requestServices } from '../../domain/constant/request.services.constant';
import solicitationService from '../../domain/services/solicitation/solicitation.service';
import datetimeProvider from '../../providers/datetime.provider';

import requestAdvanceService from '../../domain/services/request/advance.service';
import { servicesByTypeKey } from "../../domain/constant/request.services.constant";
import modalities from '../../domain/constant/modalities.constant';

import ReactPixel from 'react-facebook-pixel';
import { pixelID, options } from '../../domain/constant/pixel.constant';
import { useTour } from '../../context/tourContext';
import { tours } from '../../domain/constant/tour.constant';
import RequestCalculationAdditionalModal from './request.calculation.modal';
import { areas } from '../../domain/constant/area.constant';
import announcementService from '../../domain/services/marketing/announcement.service';
import { announcements } from '../../domain/constant/announcements.constant';
import useFinishAfterUploads from '../../hooks/upload/useFinishAfterUploads';
import useStalledUploads, { stalledSessionsOf } from '../../hooks/upload/useStalledUploads';
import StalledUploads from './stalled.uploads.component';

const UPLOAD_REFUSED_MESSAGE = 'Um arquivo não pôde ser enviado. Veja o motivo na lista de documentos e finalize de novo.';

const RequestForm = (props) => {

    ReactPixel.init(pixelID, {}, options);

    const {
        request,
        disabled,
        isSmall,
        isEdit,
        setRequest,
        discardChanges,
        onConfirm,
        setAlert,
        warningHearingAntecipation,
        showDivider,
    } = props;

    const location = useLocation();
    const history = useHistory();

    const { registerRef } = useTour();

    const refs = {
        formContainerRef: registerRef(tours.howToEditTour, 'formContainer'),
        servicesRef: registerRef(tours.howToEditTour, 'services'),
        saveRef: registerRef(tours.howToEditTour, 'save'),
    };

    const { showHearingAnalysisModal: showInitalModal } = location.state || {};

    const [dynamicFields, setDynamicFields] = useState({});
    const [editModal, setEditModal] = useState({});

    const [fieldsWithError, setFieldsWithError] = useState([]);
    const [isFieldsLoading, setIsFieldsLoading] = useState(true);

    const [isFormCompleted, setIsFormCompleted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [loading, setLoading] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [refreshDocuments, setRefreshDocuments] = useState(true);
    const [servicePrices, setServicePrices] = useState([]);
    const [submitCopyButton, setSubmitCopyButton] = useState('Finalizar Cadastro')
    const [fieldsWhoChangePrice, setFieldsWhoChangePrice] = useState([])
    const [keyswhoChangePrice, setKeyswhoChangePrice] = useState([])

    const [showHearingAnalysisModal, setShowHearingAnalysisModal] = useState(!!showInitalModal);
    const [showRequestAdditionalChargeByProcessDocumentModal, setShowRequestAdditionalChargeByProcessDocumentModal] = useState(false);

    const requestFormSteps = requestFieldsConfig.getRequestFieldsSteps(request, !isEdit, isFormCompleted);

    const hearingAnalysisModalCallback = useRef(null);

    const checkHearingMinDate = (name, request) => {

        const hearingServices = servicesByTypeKey.hearing.services;
        const isHearing = hearingServices.includes(request.mainServiceKey) || hearingServices.includes(request.serviceKey) || [requestServices.structure.hearingInPerson.id, requestServices.structure.hearing.id].includes(request.mainServiceId);

        if (name !== 'processInformation' || !isHearing)
            return {};

        const serviceKeyStrategies = {
            default: () => datetimeProvider.addBusinessDays(2),
            [requestServices.structure.hearingInPerson.id]: () => loginService.isInternal() ? datetimeProvider.addBusinessDays(0) : datetimeProvider.addBusinessDays(3),
            [requestServices.structure.hearing.id]: () => loginService.isInternal() ? datetimeProvider.addBusinessDays(0) : datetimeProvider.addBusinessDays(2),
        };

        const mainServiceId = request.mainServiceId || request.serviceId;

        const minDate = (serviceKeyStrategies[mainServiceId] || serviceKeyStrategies['default'])();

        return {
            minDate: minDate,
            warningHearingAntecipation
        };
    };

    const checkMinDate = (name = null) =>
        checkHearingMinDate(name, request);

    const fieldProps = (name = null) => ({
        ...checkMinDate(name),
        titleColor: '#000000DE',
        titleSize: 15,
        titleWeight: 600,
        spacing: 10,
        disabled: disabled || isFormCompleted || isSubmitting
    })

    const cleanUpLocationState = () => {
        history.replace({
            pathname: location.pathname,
            state: null,
        });
    }

    const getDocuments = async () => {
        if (!request.id)
            return [];

        setLoading(true);
        try {
            const { data } = await documentsService.find(request.id);
            setDocuments(data || []);
            return data || [];
        } finally {
            setLoading(false);
        }
    }

    const getDynamicFieldsWhoChangePrice = () => {
        const fieldsToChangePrice = [];

        if (request.fields == undefined || keyswhoChangePrice.length == 0)
            return;

        keyswhoChangePrice.forEach(key => {
            if (key in request.fields) {
                fieldsToChangePrice.push(request.fields[key].value);
            }
        });

        if (fieldsToChangePrice.every((value, index) => value === fieldsWhoChangePrice[index]) || (fieldsToChangePrice.length == 0 && fieldsWhoChangePrice.length == 0))
            return;

        setFieldsWhoChangePrice(fieldsToChangePrice);
    }

    useEffect(() => getDynamicFieldsWhoChangePrice(), [request.fields]);

    useEffect(() => getFields(), [request.areaId, request.modalityId]);

    useEffect(() => {
        const timer = setTimeout(() => {
            getSolicitationCheckout();
        }, 2000);

        return () => clearTimeout(timer);
    }, [
        request.areaId,
        request.modalityId,
        request.forwardCalculationServiceId,
        request.needCalculation,
        request.hearingDateTime,
        request.calculationServiceId,
        request.forwardToPetition,
        request.forwardToAnalysis,
        request.forwardModalityId,
        request.forwardToHearing,
        request.forwardToHearingAnalysis,
        request.forwardToHearingInPerson,
        request.forwardToIssuePaymentFee,
        fieldsWhoChangePrice,
        request.fields?.issueFeeQuantity?.value,
        request.hasProcessDocument,
        request.linkPremiumFaciliter
    ]);

    useEffect(() => cleanUpLocationState(), []);

    const getFields = async () => {

        let searchParams = { areaId: request.areaId, modalityId: request.modalityId };

        const isCounterView = (
            request.mainId && loginService.isFaciliter() &&
            modalities.calculation.id == request.modalityId
        );

        if (isCounterView) {
            searchParams.areaId = request.mainRequestAreaId;
            searchParams.modalityId = request.mainRequestModalityId;
        }

        return await requestFieldsConfig
            .getFields(searchParams.areaId, searchParams.modalityId)
            .then(fields => {
                setDynamicFields(requestFieldsConfig.checkToDisableFields(fields, request));
                setFieldsWithError([]);
                resolveKeysToChangePrice(fields.processInformation);
            })
            .finally(() => setIsFieldsLoading(false));
    }

    const getSolicitationCheckout = () => {
        if (!request.id)
            return

        setServicePrices([])

        solicitationService.getServicePrices({
            ...request,
            issueFeeQuantity: request.fields?.issueFeeQuantity?.value || 0
        })
            .then(async ({ data }) => {
                if (!data.hasBalance) {
                    setSubmitCopyButton('Finalizar Cadastro e Adquirir Saldo')
                }

                setServicePrices(data.servicesWithPrices)
            })
            .catch(() => { })
    }


    const resolveKeysToChangePrice = (fields) => {
        const keysToChangePrice = fields
            .filter(field => field.changeCheckoutPrice === true)
            .map(field => field.key);

        setKeyswhoChangePrice(keysToChangePrice);
    }

    const handleAnalysisModalSelection = () => {
        hearingAnalysisModalCallback.current()
            .then(() => {
                setShowHearingAnalysisModal(false);
            })
    }

    const handleProcessDocumentChargeConfirm = () => {
        setIsSubmitting(true);
        submitRequest();
    }

    const hasMandatoryDocumentsNotAnexed = (currentDocuments) => {

        const mandatoryDocumentsList = documentsService.uploadListByAreaId(request.areaId)
            .filter(item => item.required && (item.modalityIds || []).includes(request.modalityId))
            .map((item) => { return item.nameType })

        if (!mandatoryDocumentsList.length)
            return false

        const allDocumentsFound = mandatoryDocumentsList.every(mandatoryDoc => currentDocuments.some(doc => doc.nameType === mandatoryDoc));

        return !allDocumentsFound;
    }

    const removeService = (service) => {

        if (service.serviceId == requestServices.structure.calculation.id)
            return proceedCalculationRemoval()

        let newRequestValues = {}
        newRequestValues[service.serviceDatabaseFlag] = null
        newRequestValues['serviceId'] = request.mainServiceId

        setRequest({ ...request, ...newRequestValues })

        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }

    const proceedCalculationRemoval = () => {
        const newRequestValues = { forwardCalculationServiceId: null, needCalculation: false }
        setRequest({ ...request, ...newRequestValues })
    }

    const { waiting: waitingUploads, remaining: uploadsRemaining, requestFinish } = useFinishAfterUploads({
        requestId: request.id,
        onFinish: () => handleConfirm(),
        onRefused: () => setAlert(UPLOAD_REFUSED_MESSAGE, 'warning'),
    });

    const stalledUploads = useStalledUploads({
        requestId: request.id,
        onResolved: () => requestFinish(),
        onSent: () => setRefreshDocuments(previous => !previous),
    });

    const showStalledUploads = (error) => {
        const sessions = stalledSessionsOf(error);
        if (sessions) stalledUploads.show(sessions);
    };

    const handleConfirm = async () => {

        if (!request.areaId) {
            setAlert('Selecione uma área do Direito para continuar!', 'error');
            return;
        }

        setIsSubmitting(true);

        const currentDocuments = await getDocuments().catch(onDocumentsUnavailable);
        if (!currentDocuments)
            return;

        if (hasMandatoryDocumentsNotAnexed(currentDocuments))
            return onMandatoryDocumentsError()

        const hasProcessDocument = currentDocuments.find(doc => doc.isProcessMainDocument);

        if (hasProcessDocument || (!modalities[request.modalityKey]?.processDocumentRequired && !request.processNumber) || isEdit)
            return submitRequest();

        setIsSubmitting(false);

        return setShowRequestAdditionalChargeByProcessDocumentModal(true);
    }

    const onDocumentsUnavailable = (error) => {
        setIsSubmitting(false);
        clientLogger.logClientError({ context: 'request:finish:documents', message: 'leitura dos anexos falhou antes do Finalizar', payload: { requestId: request.id }, error });
        return null;
    }

    const onMandatoryDocumentsError = (err) => {

        setIsSubmitting(false);

        swal.fire({
            title: `<p style="color: #000000DE; font-family: satoshi, sans-serif; font-size: 30; font-weight: 500;">Documentos não anexados</p>`,
            html: `
                <p style="color: #000000DE; font-family: satoshi, sans-serif; font-size: 15; font-weight: 400;">Os documentos obrigatórios da solicitação não foram enviados.</p>
                <p style="color: #000000DE; font-family: satoshi, sans-serif; font-size: 15; font-weight: 400;">Por favor, anexe os documentos que estão pendentes para finalizar o cadastro.</p>
            `,
            icon: 'error',
            confirmButtonText: 'Anexar documentos',
            confirmButtonColor: "#366FD0",
        });
        return;

    }

    const onAdvanceCancelError = (err) => {

        const resData = err?.response?.data || {}

        if (resData.canSkipValidation)
            return;

        swal.fire({
            title: `<p style="color: #000000DE; font-family: satoshi, sans-serif; font-size: 30; font-weight: 500;">Não foi possível cancelar a antecipação da data de entrega!</p>`,
            html: `
                ${resData.message ? ' <p style="color: #000000DE; font-family: satoshi, sans-serif; font-size: 15; font-weight: 400;"><b>Motivo:</b> ' + resData.message : ''}
                <p style="color: #000000DE; font-family: satoshi, sans-serif; font-size: 15; font-weight: 400;">Contate o suporte ou tente novamente mais tarde!</p>
            `,
            icon: 'error',
            confirmButtonText: 'Fechar'
        });
        return;

    }

    const submitRequest = async () => {

        await onConfirm()
            .then(async () => {

                if (isEdit) {

                    if ([servicesByTypeKey.hearing.id].includes(request.serviceTypeId) && datetimeProvider.getBusinessDatesCount(request.hearingDateTime) >= 5 && request.isDueDateAdvanced) {
                        await requestAdvanceService.cancelAdvance(request.mainId || request.id, false)
                            .then(() => {
                                return;
                            }).catch(onAdvanceCancelError);
                    }

                    return;
                }

                ReactPixel.trackCustom('FinishedRequestRegistration', {});
                setIsFormCompleted(true);
                animateScroll.scrollToBottom();

            })
            .catch(showStalledUploads)
            .finally(() => setIsSubmitting(false));
    }

    const handleOpenEditModal = (initialValues, callback) =>
        setEditModal({ open: true, initialValues, callback });

    const checkIfHasNotInPersonHearing = ![request.serviceId, request.mainServiceId].includes(requestServices.structure.hearingInPerson.id)

    const exclusiveVirtualHearingFields = ['hearingApp', 'hearingLink'];

    const showVirtualHearingFields = (fieldKey) => !exclusiveVirtualHearingFields.includes(fieldKey)

    const dynamicFieldsToRender = Object.entries(dynamicFields).reduce((allFields, [key, fields]) => {

        let fieldsToFilter = [...fields];

        if (key === 'factsAndFundamentals') fieldsToFilter = fieldsToFilter.filter(field => checkIfHasNotInPersonHearing ? true : showVirtualHearingFields(field.key))

        const fieldsWithoutExcludedActions = fieldsToFilter.filter(field => !requestFieldsConfig.isExcludedActionType(request, field?.validation?.excludedActionTypes));

        return ({
            ...allFields,
            [key]: fieldsWithoutExcludedActions
        });
    }, {});

    const getContent = (item) => {

        if (isFieldsLoading)
            return (
                <Grid item xs={12}>
                    <SkeletonLoading size={{ height: 130 }} isDataLoading variant='rect' />
                </Grid>
            );

        const isValid = !item.validator || item.validator(request);

        if (!isValid)
            return 'Selecione um serviço e, se necessário, escolha uma modalidade para visualizar e preencher os campos.';

        return item.Component && (
            <item.Component
                {...props}
                refreshDocuments={refreshDocuments}
                stepFields={dynamicFieldsToRender[item.name] || []}
                fieldsWithError={fieldsWithError}
                fieldProps={fieldProps(item.name)}
                openEditModal={handleOpenEditModal}
                hearingAnalysisModalCallback={hearingAnalysisModalCallback}
                isEdit={isEdit}
            />
        );
    }

    const getSubmmitButtonLabel = () => {

        if (waitingUploads)
            return `Finalizando assim que os arquivos terminarem (${uploadsRemaining === 1 ? 'falta 1' : `faltam ${uploadsRemaining}`})`;

        if (!isSubmitting)
            return isEdit ? 'Salvar' : submitCopyButton;

        return (
            <>
                Carregando...
                <CircularProgress size={16} style={{ marginLeft: 10 }} />
            </>
        )
    }

    const closeAdditionalChargeModal = (isCancelled = false) => {
        setRefreshDocuments(!refreshDocuments);
        setShowRequestAdditionalChargeByProcessDocumentModal(false)
        if (!isCancelled) return;
        return document.getElementById('processNumber').scrollIntoView({ behavior: 'smooth', block: 'center' })
    }

    const customValidation = (fieldGroup) => {

        const customFieldValidation = {
            premiumServices: () => !!request?.fields?.linkPremiumFaciliter,
        };

        const validationAction = customFieldValidation[fieldGroup.name];

        if (!validationAction) return false;

        return validationAction();
    }

    return (
        <>

            <RequestAdditionalChargeByProcessDocument
                open={showRequestAdditionalChargeByProcessDocumentModal}
                onConfirm={handleProcessDocumentChargeConfirm}
                request={request}
                isEdit={isEdit}
                setOpen={setShowRequestAdditionalChargeByProcessDocumentModal}
                documents={documents}
                loading={loading || isSubmitting}
                getDocuments={getDocuments}
                setLoading={setLoading}
                setAlert={setAlert}
                onClose={closeAdditionalChargeModal}
                setRequest={setRequest}
            />


            {showHearingAnalysisModal && (
                <RequestHearingAdditionalModal
                    open={showHearingAnalysisModal}
                    onFinish={handleAnalysisModalSelection}
                    onClose={() => setShowHearingAnalysisModal(false)}
                />
            )}

            <div ref={refs.formContainerRef}>

                {showDivider && (
                    <Divider className='!mb-6' />
                )}

                <Grid container direction='column' style={{ gap: isSmall ? 35 : 50 }}>

                    {requestFormSteps
                        .filter(item => !request.referenceAnalysisId || item.name != "processInformation")
                        .filter(item => !item.needFieldsToRender || (dynamicFieldsToRender[item.name] || []).length > 0 || customValidation(item))
                        .map((item, index) => (
                            <React.Fragment key={item.name}>

                                {!!index && (
                                    <Grid item>
                                        <Divider />
                                    </Grid>
                                )}

                                {item.fullWidth ? getContent(item) : (
                                    <Grid
                                        item spacing={isSmall ? 6 : 0}
                                        direction={isSmall ? 'column' : 'row'}
                                        justifyContent='space-between' container
                                    >

                                        <Grid item xs={isSmall ? 12 : 4}>

                                            <Typography variant='h6' gutterBottom>
                                                <strong>{item.label(request)}</strong>
                                            </Typography>

                                            <Typography variant='caption' color='textSecondary'>
                                                {item.description && item.description(request)}
                                            </Typography>

                                            {item.extra && (
                                                <div>
                                                    {item.extra()}
                                                </div>
                                            )}

                                            {item.htmlDescription && (
                                                <div dangerouslySetInnerHTML={{ __html: item.htmlDescription(request) }} />
                                            )}

                                        </Grid>

                                        <Grid item xs={isSmall ? 12 : 7} container>
                                            <Grid xs={12}>
                                                <div
                                                    ref={item.name === 'mainInformation' ? refs.servicesRef : null}
                                                    className='p-8 md:p-10 rounded-lg bg-[#fff] border border-solid border-[#ededed] shadow-[0px_4px_4px_#0001]'
                                                >
                                                    {getContent(item)}
                                                </div>
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                )}

                            </React.Fragment>
                        ))
                    }

                    {
                        (isEdit || !isFormCompleted) && !loginService.isFaciliter() && (
                            <Grid
                                item container justifyContent='flex-end'
                                style={{ marginTop: 20 }}
                            >
                                <Grid
                                    item container direction='row-reverse'
                                    xs={isSmall ? 12 : 7}
                                >

                                    <StalledUploads
                                        rows={stalledUploads.rows}
                                        onResend={stalledUploads.resend}
                                        onFinishWithout={stalledUploads.finishWithout}
                                    />

                                    <div className='flex flex-col md:flex-row md:justify-end gap-3 w-full'>

                                        {isEdit && (
                                            <Button
                                                className='w-full md:w-auto'
                                                variant='outlined'
                                                size='large'
                                                onClick={discardChanges}
                                                disabled={fieldProps().disabled}
                                            >
                                                Cancelar
                                            </Button>
                                        )}

                                        <Button
                                            variant='contained'
                                            color='primary'
                                            size='large'
                                            className='font-semibold w-full md:w-72'
                                            onClick={requestFinish}
                                            disabled={fieldProps().disabled}
                                            ref={refs.saveRef}
                                        >
                                            {getSubmmitButtonLabel()}
                                        </Button>
                                    </div>

                                </Grid>
                            </Grid>

                        )
                    }
                </Grid >
            </div >

            <EditFieldsModal
                {...props}
                open={editModal.open}
                initialValues={editModal.initialValues}
                onSave={editModal.callback}
                onClose={() => setEditModal({})}
            />

        </>
    );
}

export default RequestForm;